<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="30%">
            <v-card class="text-center">
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearDataAdd()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row class="mb-6" justify="center">
                      <v-col md="auto">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/Object.png')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row class="mb-6" justify="center">
                      <v-col md="auto">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formAdd.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formAdd.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="6">
                        <VuetifyMoney
                          v-model="formAdd.exchangeRate"
                          label="ยอดใช้จ่ายต่อ 1 คะแนน"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                      <v-col cols="6" v-if="itemLinked.length > 0">
                        <v-select
                          v-model="formAdd.flowId"
                          :items="itemLinked"
                          label="ประเภทบริการ"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px" v-if="items.length > 0">
                      <v-col cols="12">
                        <v-combobox
                          v-show="items.length > 0"
                          v-model="value"
                          :items="items"
                          label="ร้านค้า"
                          outlined
                          light
                          multiple
                          @change="filterItem(value)"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row style="height: 65px">
                      <!-- {{formAdd.status}} -->
                      <v-checkbox
                        v-model="formAdd.status"
                        label="แสดงข้อมูล"
                        class="mx-auto"
                      ></v-checkbox>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      dark
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="30%">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearDataUpdate()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img :src="require('@/assets/Object.svg')"></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formUpdate.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formUpdate.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="6">
                        <VuetifyMoney
                          v-model="formUpdate.exchangeRate"
                          label="ยอดใช้จ่ายต่อ 1 คะแนน"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                      <v-col cols="6" v-if="itemLinked.length > 0">
                        <v-select
                          v-model="formUpdate.flowId"
                          :items="itemLinked"
                          label="ประเภทบริการ"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px" v-if="items.length > 0">
                      <v-col cols="12">
                        <v-combobox
                          v-show="items.length > 0"
                          v-model="value2"
                          :items="items"
                          label="ร้านค้า"
                          outlined
                          dense
                          multiple
                          @change="filterItem(value)"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row style="height: 65px">
                      <v-checkbox
                        v-model="formUpdate.status"
                        label="แสดงข้อมูล"
                        class="mx-auto"
                      ></v-checkbox>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      :disabled="!validUpdate"
                      color="#173053"
                      dark
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="30%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 75px">
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส ProductExchangeRate*"
                        v-model="formUpdate.productExchangeRateId"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row style="height: 75px">
                    <v-col cols="12">
                      <v-text-field
                        label="สินค้า/บริการ"
                        v-model="formUpdate.name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          x-small
                          dark
                          @click.stop="
                            ;(dialogEdit = true),
                              getData(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney
  },
  created () {},
  data () {
    return {
      PK: '',
      path: '/productExchangeRate/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สินค้าและบริการ',
          disabled: false,
          href: '/Master/ProductExchangeRate'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      //   typecoin: ['เหรียญหลัก', 'เหรียญรอง'],
      // End Menu Config
      returnLink: '/Master/ProductExchangeRate',
      dataReady: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        name: '',
        exchangeRate: 0,
        flowId: '',
        flowName: '',
        detail: '',
        status: '',
        CREATE_USER: '',
        LAST_USER: '',
        userId: [],
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        productExchangeRateId: '',
        name: '',
        flowId: '',
        exchangeRate: '',
        detail: '',
        status: '',
        userId: '',
        LAST_USER: '',
        shopId: ''
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ID', value: 'productExchangeRateId' },
        { text: 'บริการ', value: 'name' },
        { text: 'อัตราแลกเปลี่ยน', value: 'exchangeRate' },
        { text: 'รายละเอียด', value: 'detail' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      items: [],
      value: null,
      itemLinked: [],
      value2: [],
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    this.getitem()
    this.getFlowLinked()
    console.log('aassss', this.dataItem)
  },
  methods: {
    filterItem (value) {
      console.log(value)
      this.formAdd.userId = []
      value.forEach((element, key) => {
        console.log('el', element.displayName)
        this.formAdd.userId.push(element.userId)
      })
    },
    async getitem () {
      await axios
        .get(
          this.DNS_IP +
            '/system_user/get?shopId=' +
            this.session.data.shopId +
            '&userTypeGroup=Operation'
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.value = d.userId
            d.text = d.displayName
            this.items.push(d)
          }
        })
    },
    getFlowLinked () {
      axios
        .get(
          'https://api-belinked.betaskthai.com/flow/get?shopId=' +
            // 'Ucb91b5fb61ff0c01e6d7d4c5f7962c57'
            this.session.data.shopId
          //     http://localhost:8081/ConditionFlow?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&flowId=45
        )
        .then(response => {
          console.log('rsssss', response.data)
          let rs = response.data
          if (rs.status === false) {
            this.itemLinked = []
          } else {
            rs.map(el => this.itemLinked.push({
              value: el.flowId.toString(),
              text: el.flowName
            })
            )
          }
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      var search =
        '?productExchangeRateId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      this.dataReady = false
      this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'productExchangeRateId',
        item.productExchangeRateId,
        this.returnLink
      )
    },
    getData (item) {
      this.value2 = []
      axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/get?shopId=' +
            this.session.data.shopId +
            '&productExchangeRateId=' +
            item.productExchangeRateId
        )
        .then(response => {
          let rs = response.data[0]
          let a = null
          console.log('data', response.data)
          this.formUpdate.name = rs.name
          this.formUpdate.detail = rs.detail
          this.formUpdate.exchangeRate = rs.exchangeRate
          this.formUpdate.flowId = rs.flowId
          this.formUpdate.status = rs.status
          this.formUpdate.userId = rs.userId
          this.value = rs.userId
          console.log('userId', typeof rs.userId)
          // this.value = JSON.parse(rs.displayName)
          this.formUpdate.productExchangeRateId = rs.productExchangeRateId
          this.formUpdate.shopId = rs.shopId
          this.formUpdate.LAST_DATE = rs.LAST_DATE
          this.formUpdate.CREATE_DATE = rs.CREATE_DATE
          if (this.formUpdate.status === 'False') {
            this.formUpdate.status = false
          }
          console.log('ddd', rs.userId)
          a = JSON.parse(rs.userId).map(a => this.items.filter((b) => a === b.value))
          a.map(a => this.value2.push({'value': a[0].value, 'text': a[0].displayName}))
          //   if (this.value) {
          //     this.value.map(el => {
          //       this.items.filter(item => {
          //         item.value = el
          //       })
          //     })
          //   }
          console.log(this.value)
          console.log(this.items)
        })
    },
    async addData () {
      this.dataReady = false
      console.log('value', this.value)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          if (this.value !== null) {
            this.formAdd.userId = JSON.stringify(this.value.map(a => a.value))
          } else {
            this.formAdd.userId = ''
          }

          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          JSON.stringify(this.formAdd.userId)
          console.log('add', this.formAdd)
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async response => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.clearDataAdd()
              this.loadingAdd = false
            })
            .catch(error => {
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.formUpdate.userId = JSON.stringify(this.value2.map(a => a.value))
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.productExchangeRateId
          delete this.formUpdate['productExchangeRateId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          await axios
            .post(this.DNS_IP + this.path + 'edit/' + ID, this.formUpdate)
            .then(async response => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              this.clearDataUpdate()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            .catch(error => {
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.productExchangeRateId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.productExchangeRateId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearDataAdd () {
      this.formAdd.name = ''
      this.formAdd.exchangeRate = 0
      this.formAdd.detail = ''
      this.formAdd.status = ''
      this.formAdd.flowId = ''
      this.formAdd.userId = ''
      this.value = null
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    async clearDataUpdate () {
      this.formUpdate.productExchangeRateId = ''
      this.formUpdate.name = ''
      this.formUpdate.exchangeRate = 0
      //   this.formUpdate.TypeCoin = ''
      this.value = null
      this.formAdd.userId = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Master/ProductExchangeRate.vue